import { render } from "./PreviousDbmCards.vue?vue&type=template&id=1b655a60"
import script from "./PreviousDbmCards.vue?vue&type=script&lang=js"
export * from "./PreviousDbmCards.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__